module.exports = __webpack_public_path__ + "img/_SDI9703-2.5eb39981.jpg";